import { EnumBasedItem, createEnumService } from "./base";

export enum OrderStatusType {
  PAID = "paid",
  PROCESSING = "processing",
  CANCELLED = "cancelled",
}

export class OrderStatus extends EnumBasedItem<OrderStatusType> {}

const orderStatusService = createEnumService(OrderStatusType, OrderStatus);
export default orderStatusService;
